import React from "react";

import { styled, Typography } from "@mui/material";

import Stack, { Row, StackProps } from "@rui/Stack";

type ListItemProps = StackProps & { expanded: boolean; expandable: boolean };

export const ListItem = styled<React.FC<ListItemProps>>(
  ({ expanded: _e, expandable: _ex, ...props }) => <Row {...props} />
)(({ theme, expanded, expandable }) => ({
  justifyContent: "space-between",
  letterSpacing: "-0.01em",
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[600],
  fontSize: "0.875rem",
  padding: theme.spacing(0.5),
  paddingBottom: 0,
  margin: theme.spacing(0.25, 0),
  width: "100%",
  borderRadius: "4px",
  border: "solid 1px transparent",
  ...(expandable && {
    "&:hover": {
      backgroundColor: theme.palette.shades.ghost[300],
      cursor: "pointer",
    },
  }),
  ...(expanded && {
    borderColor: theme.palette.shades.neutral[100],
  }),
}));

export const StatusText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  fontSize: "0.8125rem",
  color: theme.palette.shades.neutral[500],
  lineHeight: 16 / 13,
}));

export const StatusContent = styled(Stack)(({ theme }) => ({
  rowGap: "4px",
  backgroundColor: theme.palette.shades.neutral[50],
  borderLeft: "solid 2px",
  width: "100%",
  padding: theme.spacing(0.5, 1),
  margin: theme.spacing(0.5, 0, 0.5, 0),
  borderColor: theme.palette.shades.neutral[200],
}));
